import datepicker from "js-datepicker";

const cmpDatePicker = {
    component: null,

    /**
     * Initialise the component
     * @param element
     */
    init: function (element)
    {
        const _ = this;
        _.element = element;

        const picker = datepicker(element, {
            format: 'dd/mm/yyyy'
        });
    },
}

export default cmpDatePicker;
